import axios from "axios"
import CONSTANTS from "@/store/constants";

const employeeHubInstance = axios.create({});
const enterpriseSearchInstance = axios.create({
  baseURL: CONSTANTS.ENTERPRISE_SEARCH_API_URL
});

const api = {
    getSearchResults(searchKeyword,esQuery,length){
      let query = esQuery.replace("QUERY_TOBE_REPLACED",searchKeyword);
          query = length?query.replace("ES_RESULTS_LENGTH",length):query.replace("ES_RESULTS_LENGTH",20);
          query = query.replace("`","");
          query = "{"+query+"}"

      return enterpriseSearchInstance.post("",{ query});
    },
    getAppdata(alias) {
        const solutionsQuery = `solutions {
                              name
                              pageType
                              targets {
                                id
                                linkName
                                linkValue
                                openLinkInNewTab
                                description
                                name
                                active
                                searchTags
                              }
                            }`;
        const query = `
        query{
                 getGuidedPlatformAppData(alias:"${alias}",showInActiveRecords:false){
                    alias
                    name
                    description
                    showBreadcrumb
                    enterpriseSearchQuery
                    enableEnterpriseSearch
                    redirectUrl
                    enterpriseSearchResultsLength
                    quickLinks {
                      id
                      name
                      image    
                      imageType  
                      ehOrder
                      link
                     }
                    solutionFooterTemplate{
                      solutionFooterValues{
                        linkName
                        linkValue
                        linkPrefix
                        linkSuffix
                      }
                    }
                    supportList {
                      title
                      value
                    }
                    categories {
                      id
                      name
                      image    
                      imageType  
                      ehOrder
                      searchTags
                      helpfulLinks {
                        title
                        value
                      }
                       policies {
                        title
                        value
                      }
                      support {
                        title
                        value
                      }
                      categoryMetaData {
                        childrenPageType 
                        title
                      }
                      description
                      childCategories {
                        id
                        name
                        ehOrder
                        searchTags
                        parentCategoryId
                        categoryMetaData {
                          title
                        }${solutionsQuery}
                        description
                        childCategories {
                          id
                          name
                          ehOrder
                          searchTags
                          parentCategoryId
                          categoryMetaData {
                            title
                          }${solutionsQuery}                         
                          description
                          childCategories {
                            id
                            name
                            ehOrder
                            searchTags
                            parentCategoryId
                            categoryMetaData {
                              title
                            }
                            description
                            ${solutionsQuery}
                          }
                        }
                      }
                    }
               }
           }`

        return employeeHubInstance.post(
            "/guides/graphql", {
                query
        });
    }
};
export default api;